import React, { useCallback, useMemo } from 'react';
import { Divider, Modal, Spin } from 'antd';
import { CollectionServer, GetMetaProperties, QueryDetail, SetMetaProperties, clean, deleteInArray, deleteInProperties, foreachInProperties, getObjectDisplay, updateInArray, useMetaContext, updateInPropertiesUUID, contextFilterToObject, GET, QueryParam, QueryOrder, JSXMap } from 'fennec-ui'
import { POST, errorCatch, ObjectToContextFilters, ContextFiltersToQueryFilters } from 'fennec-ui'
import { ExclamationCircleOutlined } from '@ant-design/icons';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import ObjectOwnerDescription from '../../../fedance-ui/ObjectOwnerDescription';
import { render } from 'react-dom';
import ObjectVtpDescription, { ObjectVtpDescriptionString } from '../../../fedance-ui/ObjectVtpDescription';
import User from '../../../common/User';
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale('ru');

var _ = require('lodash');

const ShablonRender = (props) => {
    const { item, style } = props;
    return (<div style={style}>
        <div>{item?.nastroikaEkvairinga?.nastroiki?.nazvanie}</div>
        {/* <div style={{ color: "#6a6a6a" }}><ObjectOwnerDescription object={item} inline={true} /></div> */}
        {/* <div>{getObjectDisplay(item, "ShabloniSudeiskikhGonorarov", meta)}</div> */}
        <div style={{ color: "#6a6a6a" }}>
            <ObjectVtpDescription object={item?.vtp} style={{ marginBottom: "5px" }} extend={() => ((item?.vtp?.tipPolzovatelya) ? <div style={{ fontSize: "11px" }}>{item?.vtp?.tipPolzovatelya?.opisanie}</div> : null)} />
        </div>
    </div>)
}

export default function EkvairingOrgBlock(props) {
    const { auth, source, create, ctx, sourceKey, title, size, event } = props;

    const meta = useMetaContext();

    const filtersFromMeta = React.useCallback((name) => {
        let prop = [];
        let p = GetMetaProperties(meta[name])
        p = deleteInProperties(p, ["CreatedAt", "UpdatedAt", "DeletedAt", "ID"])

        p = foreachInProperties(p, n => (_.get(n, "relation.reference.object") == "NastroikiEkvairinga"), {
            source: `/api/nastroikiekvairinga/list`,
            display: (o) => o?.nastroiki?.nazvanie,
            queryFilter: [QueryDetail("model")]
        })
        p = foreachInProperties(p, n => (_.get(n, "relation.reference.object") == "VseTipiPolzovatelei"), {
            source: `/api/vsetipipolzovatelei/all/list`,
            display: (o) => (<ObjectVtpDescription object={o} style={{ marginBottom: "5px" }} extend={() => ((o?.tipPolzovatelya) ? <div style={{ fontSize: "11px", color: "rgba(0,0,0,.85)" }}>{o?.tipPolzovatelya?.opisanie}</div> : null)} />),
            queryFilter: [QueryParam("w-in-tipPolzovatelya", "15,18,23"), QueryOrder("tipPolzovatelya", "ASC"), QueryDetail("model")]
        })

        if (p) {
            prop = p?.filter(e => !_.get(e, "relation") || _.get(e, "relation.type") !== "one-many")?.map(e => ({ ...e, sort: true, filter: true, func: (e.filterType == "range") ? ["min", "max"] : undefined }))
        }
        return prop;
    }, [meta]);
    const cleanProperties = (obj, context, funcs) => {
        const { name, field, fieldName, contextObject, object } = context;

        if (!obj) { return obj }

        let p = GetMetaProperties(obj)

        p = deleteInProperties(p, ["CreatedAt", "UpdatedAt", "DeletedAt"])

        if (object && obj.type == "object") {
            p = updateInPropertiesUUID(p, {
                uuid: "object-owner-description",
                type: "func",
                render: () => (<ObjectOwnerDescription object={object} style={{ marginBottom: "5px" }} />)
            }, true)
        }

        if (contextObject && obj.type == "object" && field) {
            let fName = _.get(field, "relation.reference.property");
            let o = obj?.properties?.find(e => e.name == fName)
            if (o) {
                let oObj = _.get(o, "relation.reference.object");
                let oMeta = meta[oObj];
                p = updateInPropertiesUUID(p, {
                    uuid: "object-context-description",
                    type: "func",
                    render: () => (<div className='bg bg-grey' style={{ textAlign: "left", padding: "5px", marginBottom: "5px" }}>
                        {(oMeta) && <div style={{
                            fontSize: "10px",
                            color: "rgb(106, 106, 106)",
                            lineHeight: "10px",
                            fontStyle: "italic"
                        }}>{o?.label} ({oMeta?.label})</div>}
                        <div>{getObjectDisplay(contextObject, oObj, meta)}</div>
                        <div style={{ color: "#6a6a6a" }}><ObjectOwnerDescription object={contextObject} inline={true} /></div>
                    </div>)
                }, true)
            }
        }

        p = foreachInProperties(p, n => (_.get(n, "relation.reference.object") == "NastroikiEkvairinga"), {
            source: `/api/nastroikiekvairinga/list`,
            display: (o) => o?.nastroiki?.nazvanie,
            queryFilter: [QueryDetail("model")]
        })
        p = foreachInProperties(p, n => (_.get(n, "relation.reference.object") == "VseTipiPolzovatelei"), {
            // source: `/api/vsetipipolzovatelei/all/list`,
            // display: (o) => (<ObjectVtpDescription object={o} style={{ marginBottom: "5px" }} extend={() => ((o?.tipPolzovatelya) ? <div style={{ fontSize: "11px", color: "rgba(0,0,0,.85)" }}>{o?.tipPolzovatelya?.opisanie}</div> : null)} />),
            queryFilter: [QueryParam("w-in-tipPolzovatelya", "15,18,23"), QueryOrder("tipPolzovatelya", "ASC"), QueryDetail("model")],

            mode: "dialog",
            modal: { width: "900px" },
            // filters: () => filtersFromMeta("VseTipiPolzovatelei"),
            relation: {
                uiFilter: () => [
                    {
                        "name": "TipPolzovatelya",
                        "type": "object",
                        "label": "Тип пользователя",
                        "relation": {
                            "type": "many-one",
                            displayString: (item) => {
                                return item?.opisanie
                            },
                            display: (item) => {
                                return (
                                    item?.opisanie
                                )
                            },
                            "reference": {
                                "object": "TipiPolzovatelei",
                                "property": "ID"
                            },
                        },
                        queryFilter: [
                            QueryOrder("opisanie", "ASC")
                        ],
                        "sort": true,
                        "filter": true
                    },
                    {
                        label: <div style={{ lineHeight: "16px", marginBottom: "3px" }}>
                            <div style={{ fontSize: "12px", fontWeight: "lighter", color: "#6a6a6a" }}>Пользователь</div>
                            <div>email</div>
                        </div>,
                        name: "User.email",
                        sort: true,
                        filter: true,
                    },
                    {
                        mode: "dialog",
                        "name": "User",
                        "type": "object",
                        "label": "Пользователь",
                        "relation": {
                            uiFilter: () => [
                                {
                                    name: "lastname",
                                    sort: true,
                                    filter: true,
                                },
                                {
                                    name: "firstname",
                                    sort: true,
                                    filter: true,
                                },
                                {
                                    name: "patronymic",
                                    sort: true,
                                    filter: true,
                                },

                                {
                                    name: "email",
                                    sort: true,
                                    filter: true,
                                },
                                {
                                    label: "Телефон",
                                    name: "phone",
                                    sort: true,
                                    filter: true,
                                },
                                {
                                    name: "gender",
                                    sort: true,
                                    filter: true,
                                    display: (o) => o.name,
                                },
                                {
                                    label: "Дата создания",
                                    name: "createdAt",
                                    type: "date",
                                    sort: true,
                                    filter: true,
                                },
                            ],
                            displayString: (item) => {
                                return item?.lastname + " " + item?.firstname
                            },
                            display: (item) => {
                                return (
                                    <User item={item} />
                                )
                            },
                            "type": "many-one",
                            "reference": {
                                "object": "User",
                                "property": "ID"
                            },
                        },
                        "sort": true,
                        "filter": true
                    },
                    {
                        "name": "Shkola",
                        "type": "object",
                        "label": "Школа",
                        "relation": {
                            "type": "many-one",
                            "reference": {
                                "object": "ShkoliFederatsii",
                                "property": "ID"
                            },
                        },
                        queryFilter: [
                            QueryDetail("collection")
                        ],
                        "sort": true,
                        "filter": true
                    },
                    {
                        "name": "Shkola.RegionalnoeOtdelenie",
                        "type": "object",
                        "label": <div style={{ lineHeight: "16px", marginBottom: "3px" }}>
                            <div style={{ fontSize: "12px", fontWeight: "lighter", color: "#6a6a6a" }}>Школа</div>
                            <div>Региональное отделение</div>
                        </div>,
                        "relation": {
                            "type": "many-one",
                            "reference": {
                                "object": "RegionalnieOtdeleniya",
                                "property": "ID"
                            },
                        },
                        queryFilter: [
                            QueryDetail("collection")
                        ],
                        "sort": true,
                        "filter": true
                    },
                    {
                        mode: "dialog",
                        "name": "Organizator",
                        "type": "object",
                        "label": "Организатор",
                        "relation": {
                            uiFilter: () => [
                                {
                                    name: "nazvanie",
                                    sort: true,
                                    filter: true,
                                },
                                {
                                    name: "user.lastname",
                                    sort: true,
                                    filter: true,
                                },
                                {
                                    name: "user.firstname",
                                    sort: true,
                                    filter: true,
                                },
                                {
                                    name: "user.patronymic",
                                    sort: true,
                                    filter: true,
                                },

                                {
                                    name: "user.email",
                                    sort: true,
                                    filter: true,
                                },
                                {
                                    label: "Телефон",
                                    name: "user.phone",
                                    sort: true,
                                    filter: true,
                                },
                                {
                                    name: "user.gender",
                                    sort: true,
                                    filter: true,
                                    display: (o) => o.name,
                                },
                                {
                                    label: "Дата создания",
                                    name: "user.createdAt",
                                    type: "date",
                                    sort: true,
                                    filter: true,
                                },
                            ],
                            "type": "many-one",
                            "reference": {
                                "object": "OrganizatoriFederatsii",
                                "property": "ID"
                            },
                        },
                        queryFilter: [
                            QueryDetail("collection")
                        ],
                        "sort": true,
                        "filter": true
                    },
                    {
                        "name": "Organizator.RegionalnoeOtdelenie",
                        "type": "object",
                        "label": <div style={{ lineHeight: "16px", marginBottom: "3px" }}>
                            <div style={{ fontSize: "12px", fontWeight: "lighter", color: "#6a6a6a" }}>Организатор</div>
                            <div>Региональное отделение</div>
                        </div>,//"Организатор - Региональное отделение",
                        "relation": {
                            "type": "many-one",
                            "reference": {
                                "object": "RegionalnieOtdeleniya",
                                "property": "ID"
                            },
                        },
                        queryFilter: [
                            QueryDetail("collection")
                        ],
                        "sort": true,
                        "filter": true
                    },
                    // {
                    //     "name": "Tantsor",
                    //     "type": "object",
                    //     "label": "Танцор",
                    //     "relation": {
                    //         "type": "many-one",
                    //         "reference": {
                    //             "object": "TantsoriFederatsii",
                    //             "property": "ID"
                    //         },
                    //     },
                    //     queryFilter: [
                    //         QueryDetail("collection")
                    //     ],
                    //     "sort": true,
                    //     "filter": true
                    // },
                    {
                        "name": "Tantsor.RegionalnoeOtdelenie",
                        "type": "object",
                        "label": <div style={{ lineHeight: "16px", marginBottom: "3px" }}>
                            <div style={{ fontSize: "12px", fontWeight: "lighter", color: "#6a6a6a" }}>Танцор</div>
                            <div>Региональное отделение</div>
                        </div>,
                        "relation": {
                            "type": "many-one",
                            "reference": {
                                "object": "RegionalnieOtdeleniya",
                                "property": "ID"
                            },
                        },
                        queryFilter: [
                            QueryDetail("collection")
                        ],
                        "sort": true,
                        "filter": true
                    },
                    // {
                    //     "name": "Sudya",
                    //     "type": "object",
                    //     "label": "Судья",
                    //     "relation": {
                    //         "type": "many-one",
                    //         "reference": {
                    //             "object": "SudiFederatsii",
                    //             "property": "ID"
                    //         },
                    //     },
                    //     queryFilter: [
                    //         QueryDetail("collection")
                    //     ],
                    //     "sort": true,
                    //     "filter": true
                    // },
                    {
                        "name": "Sudya.RegionalnoeOtdelenie",
                        "type": "object",
                        "label": <div style={{ lineHeight: "16px", marginBottom: "3px" }}>
                            <div style={{ fontSize: "12px", fontWeight: "lighter", color: "#6a6a6a" }}>Судья</div>
                            <div>Региональное отделение</div>
                        </div>,
                        "relation": {
                            "type": "many-one",
                            "reference": {
                                "object": "RegionalnieOtdeleniya",
                                "property": "ID"
                            },
                        },
                        queryFilter: [
                            QueryDetail("collection")
                        ],
                        "sort": true,
                        "filter": true
                    },
                    // {
                    //     "name": "Prepodavatel",
                    //     "type": "object",
                    //     "label": "Преподаватель",
                    //     "relation": {
                    //         "type": "many-one",
                    //         "reference": {
                    //             "object": "PrepodavateliFederatsii",
                    //             "property": "ID"
                    //         },
                    //     },
                    //     queryFilter: [
                    //         QueryDetail("collection")
                    //     ],
                    //     "sort": true,
                    //     "filter": true
                    // },
                    {
                        "name": "Prepodavatel.RegionalnoeOtdelenie",
                        "type": "object",
                        "label": <div style={{ lineHeight: "16px", marginBottom: "3px" }}>
                            <div style={{ fontSize: "12px", fontWeight: "lighter", color: "#6a6a6a" }}>Преподаватель</div>
                            <div>Региональное отделение</div>
                        </div>,
                        "relation": {
                            "type": "many-one",
                            "reference": {
                                "object": "RegionalnieOtdeleniya",
                                "property": "ID"
                            },
                        },
                        queryFilter: [
                            QueryDetail("collection")
                        ],
                        "sort": true,
                        "filter": true
                    },
                    // {
                    //     // mode: "dialog",
                    //     "name": "Kollektiv",
                    //     "type": "object",
                    //     "label": "Коллектив",
                    //     "relation": {
                    //         "type": "many-one",
                    //         "reference": {
                    //             "object": "KollektiviFederatsii",
                    //             "property": "ID"
                    //         },
                    //     },
                    //     queryFilter: [
                    //         QueryDetail("collection")
                    //     ],
                    //     "sort": true,
                    //     "filter": true
                    // },
                    {
                        "name": "Kollektiv.RegionalnoeOtdelenie",
                        "type": "object",
                        "label": <div style={{ lineHeight: "16px", marginBottom: "3px" }}>
                            <div style={{ fontSize: "12px", fontWeight: "lighter", color: "#6a6a6a" }}>Коллектив</div>
                            <div>Региональное отделение</div>
                        </div>,
                        "relation": {
                            "type": "many-one",
                            "reference": {
                                "object": "RegionalnieOtdeleniya",
                                "property": "ID"
                            },
                        },
                        queryFilter: [
                            QueryDetail("collection")
                        ],
                        "sort": true,
                        "filter": true
                    },
                    // {
                    //     "name": "Para",
                    //     "type": "object",
                    //     "label": "Пара",
                    //     "relation": {
                    //         "type": "many-one",
                    //         "reference": {
                    //             "object": "PariFederatsii",
                    //             "property": "ID"
                    //         },
                    //     },
                    //     queryFilter: [
                    //         QueryDetail("collection")
                    //     ],
                    //     "sort": true,
                    //     "filter": true
                    // },
                    {
                        "name": "Para.RegionalnoeOtdelenie",
                        "type": "object",
                        "label": <div style={{ lineHeight: "16px", marginBottom: "3px" }}>
                            <div style={{ fontSize: "12px", fontWeight: "lighter", color: "#6a6a6a" }}>Пара</div>
                            <div>Региональное отделение</div>
                        </div>,
                        "relation": {
                            "type": "many-one",
                            "reference": {
                                "object": "RegionalnieOtdeleniya",
                                "property": "ID"
                            },
                        },
                        queryFilter: [
                            QueryDetail("collection")
                        ],
                        "sort": true,
                        "filter": true
                    },
                    // {
                    //     "name": "ChlenFederatsii",
                    //     "type": "object",
                    //     "label": "Член федерации",
                    //     "relation": {
                    //         "type": "many-one",
                    //         "reference": {
                    //             "object": "ChleniFederatsii",
                    //             "property": "ID"
                    //         },
                    //     },
                    //     queryFilter: [
                    //         QueryDetail("collection")
                    //     ],
                    //     "sort": true,
                    //     "filter": true
                    // },
                    // {
                    //     "name": "ChlenFederatsii.RegionalnoeOtdelenie",
                    //     "type": "object",
                    //     "label": <div style={{lineHeight: "16px", marginBottom:"3px"}}>
                    //         <div style={{ fontSize: "12px", fontWeight: "lighter", color:"#6a6a6a"}}>Член федерации</div>
                    //         <div>Региональное отделение</div>
                    //     </div>,
                    //     "relation": {
                    //         "type": "many-one",
                    //         "reference": {
                    //             "object": "RegionalnieOtdeleniya",
                    //             "property": "ID"
                    //         },
                    //     },
                    //     queryFilter: [
                    //         QueryDetail("collection")
                    //     ],
                    //     "sort": true,
                    //     "filter": true
                    // },
                    // {
                    //     "name": "RegionalnoeOtdelenie",
                    //     "type": "object",
                    //     "label": "Региональное отделение",
                    //     "relation": {
                    //         "type": "many-one",
                    //         "reference": {
                    //             "object": "RegionalnieOtdeleniya",
                    //             "property": "ID"
                    //         },
                    //     },
                    //     "sort": true,
                    //     "filter": true
                    // },
                ],
                displayString: (item) => {
                    return ObjectVtpDescriptionString(item)
                },
                display: (item) => {
                    return (<div className={`bg bg-grey-hover light`} style={{ textAlign: "left" }}>
                        {/* <User item={item?.user} /> */}
                        <div style={{
                            fontSize: "12px",  textAlign: "left", textWrap: "nowrap",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis"
                        }}>{item?.tipPolzovatelya?.opisanie}</div>
                        <div style={{
                            fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.75)", textAlign: "left", textWrap: "nowrap",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis"
                        }}><ObjectVtpDescription object={item} /></div>
                    </div>
                    )
                },
                reference: { object: "VseTipiPolzovatelei", property: "ID", source: "/api/vsetipipolzovatelei/all/list" },
                type: "many-one",
            },
            // queryFilter: [...ContextFiltersToQueryFilters(ObjectToContextFilters(ctx)), QueryDetail("collection")]
        })

        // p = foreachInProperties(p, n => (_.get(n, "relation.reference.object") == "EkvairingType"), {
        //     // source: source,
        //     // queryFilter: [...ContextFiltersToQueryFilters(ObjectToContextFilters(ctx)), QueryDetail("collection")]
        //     display: (o) => o.nazvanie,
        // })

        // p = foreachInProperties(p, n => (name == "EkvairingOrganizatora" && (n.name == "Password" || n.name == "PasswordDev")), {
        //     // source: `/api/NastroikiEkvairinga/byorganizator/${object?.ID}`
        //     type: "password",
        //     validators: [{ max: null }]
        // })

        // console.log(p);

        if (funcs) {
            for (let i = 0; i < funcs.length; i++) {
                const f = funcs[i];
                p = f(p);
            }
        }

        return SetMetaProperties(obj, p)
    }
    const mactions = (e, mobject, { name, field, fieldName, contextObject, object: item }) => {
        const { key, action, contextFilters } = e;
        if (name == "EkvairingOrganizatora" && key == "create") {
            return (values, unlock, close, { collection, setCollection }) => {
                let ctxFlt = contextFilterToObject(contextFilters);
                POST(auth, "/api/ekvairingorganizatora/create",
                    { ...values, ...ctxFlt, ...((event?.ID) ? { meropriyatieID: event.ID } : {}) },
                    ({ data }) => {
                        setCollection(updateInArray(collection, data))
                        close()
                    }, (err) => errorCatch(err, unlock));
            }
        } else if (name == "EkvairingOrganizatora" && key == "update") {
            return (values, unlock, close, { collection, setCollection }) => {
                let ctxFlt = contextFilterToObject(contextFilters);
                POST(auth, "/api/ekvairingorganizatora/update",
                    { ...values, ...ctxFlt, ID: item.ID },
                    ({ data }) => {
                        setCollection(updateInArray(collection, data))
                        close()
                    }, (err) => errorCatch(err, unlock));
            }
        } else if (name == "EkvairingOrganizatora" && key == "delete") {
            return (values, unlock, close, { collection, setCollection }) => {
                Modal.confirm({
                    title: `Вы уверены что хотите удалить элемент?`,
                    icon: <ExclamationCircleOutlined />,
                    content: (<div>
                        {(mobject) && <div style={{ fontSize: "12px", color: "grey" }}>
                            <div>{mobject?.label}</div>
                        </div>}
                        <div>{getObjectDisplay(item, name, meta)}</div>
                    </div>),
                    okText: "Да",
                    okType: 'danger',
                    cancelText: "Нет",
                    onOk: () => {
                        GET(auth, `/api/ekvairingorganizatora/delete/${item?.ID}`,
                            () => {
                                setCollection(deleteInArray(collection, item))
                            }, errorCatch
                        );
                    },
                });
            }
        }
        // else if (name == "NastroikiEkvairinga" && key == "create") {
        //     return (values, unlock, close, { collection, setCollection }) => {
        //         let ctxFlt = contextFilterToObject(contextFilters);
        //         POST(auth, "/api/NastroikiEkvairinga/new",
        //             { ...values, ...ctxFlt },
        //             ({ data }) => {
        //                 setCollection(updateInArray(collection, data))
        //                 close()
        //             }, (err) => errorCatch(err, unlock));
        //     }
        // } else if (name == "NastroikiEkvairinga" && key == "update") {
        //     return (values, unlock, close, { collection, setCollection }) => {
        //         let ctxFlt = contextFilterToObject(contextFilters);
        //         POST(auth, "/api/NastroikiEkvairinga/update",
        //             { ...values, ...ctxFlt, ID: item.ID },
        //             ({ data }) => {
        //                 setCollection(updateInArray(collection, data))
        //                 close()
        //             }, (err) => errorCatch(err, unlock));
        //     }
        // } else if (name == "NastroikiEkvairinga" && key == "delete") {
        //     return (values, unlock, close, { collection, setCollection }) => {
        //         Modal.confirm({
        //             title: `Вы уверены что хотите удалить элемент?`,
        //             icon: <ExclamationCircleOutlined />,
        //             content: (<div>
        //                 {(mobject) && <div style={{ fontSize: "12px", color: "grey" }}>
        //                     <div>{mobject?.label}</div>
        //                 </div>}
        //                 <div>{getObjectDisplay(item, name, meta)}</div>
        //             </div>),
        //             okText: "Да",
        //             okType: 'danger',
        //             cancelText: "Нет",
        //             onOk: () => {
        //                 POST(auth, "/api/NastroikiEkvairinga/delete", item,
        //                     () => {
        //                         setCollection(deleteInArray(collection, item))
        //                     }, errorCatch
        //                 );
        //             },
        //         });
        //     }
        // }
        return action
    }

    // const x = useCallback(() => ObjectToContextFilters(ctx), [ctx])
    return (<div>
        {title || <Divider type="horizontal" orientation="left">
            Эквайринг организатора
        </Divider>}
        <CollectionServer
            auth={auth}
            name={"EkvairingOrganizatora"}
            source={source}
            queryDetail={"model"}
            filters={() => filtersFromMeta("EkvairingOrganizatora")}
            // contextFilters={x}

            mode="list"
            render={(item, idx) => (
                <div style={{ padding: "0px 5px" }}>
                    <ShablonRender item={item} />
                </div>
            )}

            linksModelActions={"inline"}
            scheme={[
                // "NastroikiEkvairingaNastroiki"
            ]}

            modelActions={(item, index, { mobject, name, field, fieldName, contextObject, collection, actions }) => {
                return actions.map(e => ({
                    ...e,
                    action: mactions(e, mobject, { name, field, fieldName, contextObject, object: item }),
                    meta: cleanProperties(mobject, { name, field, fieldName, contextObject, object: item })
                }))
            }}
            collectionActions={({ mobject, name, field, fieldName, contextObject, collection, actions }) => {
                let funcs = []
                let ac = actions.map(e => ({
                    ...e,
                    action: mactions(e, mobject, { name, field, fieldName, contextObject, object: undefined }),
                    meta: cleanProperties(mobject, { name, field, fieldName, contextObject, object: undefined }, funcs)
                }))
                return ac
            }}
        />
    </div>);
}
